import axios from 'axios';

export interface BulkSupraLockboxProcessedResult {
  successfulIds: string[];
  failedIds: string[];
  failedIdsWithErrors?: { id: string; errorMessage: string }[];
  successCount: number;
  failureCount: number;
}

const bulkCreateShacklePermissions = async ({
  userId,
  lockboxIds,
  serialNumbers,
  ownerOrAssigneeType,
  grantOfficeShacklePermissions,
}: {
  userId: string;
  lockboxIds: string[];
  serialNumbers: string[];
  ownerOrAssigneeType: 'user' | 'office';
  grantOfficeShacklePermissions?: boolean;
}): Promise<BulkSupraLockboxProcessedResult> => {
  const { data } = await axios.post<BulkSupraLockboxProcessedResult>(
    '/supra/lockbox/bulk_create_shackle_permissions',
    {
      userId,
      lockboxIds,
      serialNumbers,
      ownerOrAssigneeType,
      grantOfficeShacklePermissions,
    },
  );

  return data;
};

export default bulkCreateShacklePermissions;
